<!-- <div class="main-body app sidebar-mini" [ngClass]="mainSidebarOpen"> -->

  <app-switcher></app-switcher>
  <!-- Page -->
   <app-loader></app-loader> 
  <div class="page">
    <header class="app-header">
    <!-- // header -->
    <app-header></app-header>
    </header>
    <!-- Sidebar-right-->
    <app-notification-sidebar  ></app-notification-sidebar>
    <!--/Sidebar-right-->
    <!-- main-sidemenu -->
    <app-sidemenu appHoverEffectSidebar></app-sidemenu>
    <!-- main-sidemenu --> 
    <!-- main-content -->
    <div class="main-content app-content" (click)="BodyClick()" >
      <!-- main-header --> 
      <div class="container-fluid">
      <!-- /main-header -->

      <!-- container -->
      <div class="d-block align-items-center justify-content-between" >
        <router-outlet>
         
        </router-outlet>
      </div>
      <!-- /Container -->
      </div> 
    </div>
    <!-- /main-content -->
    <!-- Footer opened -->
    <app-footer></app-footer>
    <!-- Footer closed -->   
    <app-tap-to-top></app-tap-to-top>
    <div id="responsive-overlay" class="" (click)="clearToggle()"></div>
  </div>
  <!-- End Page -->

<!-- </div> -->
